import { Group } from "@mantine/core";
import { BackIcon, CloseIcon, HomeIcon, RestartIcon } from "../assets";
import { GuideNavButton } from "./GuideNavButton";

interface GuideNavigationProps {
    isErrorState?: boolean;
    isLoading?: boolean;
    hasCompletedSteps: boolean;
    onBack: VoidFunction;
    onRestart: VoidFunction;
    onClose: (source: "cta" | "navigation") => void;
}

export function GuideNavigation({
    isErrorState,
    isLoading,
    hasCompletedSteps,
    onBack,
    onRestart,
    onClose,
}: GuideNavigationProps) {
    return (
        <Group justify="flex-end" gap="0rem">
            {!isErrorState && hasCompletedSteps && (
                <GuideNavButton
                    disabled={isLoading}
                    key="guide-navigation-button-back"
                    tooltip="Go back"
                    onClick={onBack}
                >
                    <BackIcon />
                </GuideNavButton>
            )}
            {hasCompletedSteps && (
                <GuideNavButton
                    disabled={isLoading}
                    key="guide-navigation-button-restart"
                    tooltip={isErrorState ? "Restart guide" : "Return home"}
                    onClick={onRestart}
                >
                    {isErrorState ? <RestartIcon width={20} height={20} /> : <HomeIcon width={24} height={24} />}
                </GuideNavButton>
            )}
            <GuideNavButton
                key="guide-navigation-button-close"
                tooltip="Close guide"
                onClick={() => onClose("navigation")}
            >
                <CloseIcon />
            </GuideNavButton>
        </Group>
    );
}
